import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className="min-h-screen bg-ag-black-800">
      <Header onMenuToggle={toggleSidebar} />
      <div className="flex pt-16 md:pt-20">
        <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
        {/* Overlay for mobile when sidebar is open */}
        {isSidebarOpen && (
          <div 
            className="fixed inset-0 bg-black/50 z-30 lg:hidden"
            onClick={closeSidebar}
          />
        )}
        <main className="flex-1 lg:ml-64 w-full">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;